import { render, staticRenderFns } from "./highLight.vue?vue&type=template&id=2cd18a56&scoped=true"
import script from "./highLight.vue?vue&type=script&lang=js"
export * from "./highLight.vue?vue&type=script&lang=js"
import style0 from "./highLight.vue?vue&type=style&index=0&id=2cd18a56&prod&scoped=true&lang=css"
import style1 from "./highLight.vue?vue&type=style&index=1&id=2cd18a56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd18a56",
  null
  
)

export default component.exports